export default "__VITE_ASSET__Didq8zaM__"